var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786,
    height: 558,
    viewBox: "0 0 786 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540.083 280.53C540.07 280.522 540.056 280.514 540.043 280.506L704.014 0C741.676 21.476 769.157 56.849 780.412 98.3374C791.668 139.826 785.776 184.031 764.032 221.228C742.288 258.426 706.473 285.569 664.467 296.685C624.007 307.393 580.995 302.388 544.23 282.814L713.16 558H379L540.083 280.53Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H208.973L209.973 169.225H143.027V73.1944H65.946V484.806H124.444V558H0V0Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.973 558H170L169 388.775H235.946L235.946 484.806H313.027L313.027 73.1945H254.529V0H378.973L378.973 558Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.79a52504d9f29a52ce79c16964a77467.svg";
export { ForwardRef as ReactComponent };